import ChildTerm from "./childTerm";

function Entity({
	value,
	id,
	isRefined,
	label,
	highlighted,
	count,
	children,
	type
}) {
	if ( children && children.length > 0 ) {
		children = children.map( child => ChildTerm( { item: child } ) ).join( "" );
	} else {
		children = '';
	}

	const toggleOpen = type === 'content_type' ? 'true' : 'false';
	
	return `
	<div class="item-parent item-parent flex flex-wrap justify-between gap-2">
		<label class="inline-checkbox" data-term="${label}">
			<input class="form-checkbox" type="checkbox" value="${value}" ${
		isRefined ? "checked" : ""
	}>
			<span class="">${label} (${count})</span>
			${children && 
			`<button class="btn text-btn sub-filters-toggle" type="button" uk-toggle="target: #${id}; animation: reveal-top" aria-expanded="${ toggleOpen }">
				<span class="sr-only">Expand ${ label }</span>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="angle / small / down / thick">
						<path id="Path" d="M5 9.27504L12 17L19 9.27504L17.4274 8L12 13.9901L6.5726 8L5 9.27504Z" fill="black"></path>
					</g>
				</svg>
			</button>`
			}
		</label>
		<div id="${id}" ${toggleOpen == 'true' && ( id == 'Research' || id == 'Commentary' ) ? '' : 'hidden="" '}class="sub-filters">
			<div class="sub-filters-wrapper">
				${children}
			</div>
		</div>
	</div>`;
}

export default Entity;